import {gridItem} from '~/design-system/foundations'
import {HgApplePodcastEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgApplePodcastEmbed'
import {HgInstagramEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgInstagramEmbed'
import {HgLinkedInEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgLinkedInEmbed'
import {HgSoundCloudEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgSoundCloudEmbed'
import {HgSpotifyEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgSpotifyEmbed'
import {HgVimeoEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgVimeoEmbed'
import {HgXEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgXEmbed'
import {HgYoutubeEmbed} from '~/design-system/hg/components/HgEmbed/_components/HgYoutubeEmbed'
import {cn, unreachableCase} from '~/design-system/utils'
import type {HgEmbedProps} from '~/design-system/hg/components/HgEmbed'

const HgArticleWYSIWYGEmbed = ({
  source,
  url,
  ...props
}: HgEmbedProps & {className?: string}) => {
  switch (source) {
    case 'applePodcast':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgApplePodcastEmbed url={url} />
        </div>
      )
    case 'instagram':
      return (
        <div
          className={cn(
            'col-span-full md:col-span-6 md:col-start-4 lg:col-start-6',
            props?.className
          )}
        >
          <HgInstagramEmbed url={url} />
        </div>
      )
    case 'linkedIn':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgLinkedInEmbed
            height={'height' in props ? props.height : '100%'}
            url={url}
          />
        </div>
      )
    case 'soundCloud':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgSoundCloudEmbed url={url} />
        </div>
      )
    case 'spotify':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgSpotifyEmbed url={url} />
        </div>
      )
    case 'vimeo':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgVimeoEmbed url={url} />
        </div>
      )
    case 'youtube':
      return (
        <div
          className={gridItem({
            size: 'heading',
            className: props?.className,
          })}
        >
          <HgYoutubeEmbed url={url} />
        </div>
      )
    case 'x':
      return (
        <div
          className={cn(
            'col-span-full md:col-span-6 md:col-start-4 lg:col-start-6',
            props?.className
          )}
        >
          <HgXEmbed url={url} />
        </div>
      )
    default:
      return unreachableCase(source)
  }
}

export default HgArticleWYSIWYGEmbed
